import React, { FC, ReactNode } from 'react';
import cn from 'classnames';
import { usePopupContext } from '../../contexts/Settings';
import { isGridLayout, popupLayoutCssPostfix, Settings } from '../../types';

type Props = {
  clickable?: boolean;
  id?: string;
  children?: ReactNode;
};

function createPopupLayoutIconClasses(settings: Settings): string {
  if (isGridLayout(settings)) {
    return 'offer-image-grid';
  } else {
    switch (settings.image_size) {
      case 'small':
        return 'Offer-Icon offer-image-container-small';
      case 'medium':
        return 'Offer-Icon offer-image-container-medium';
      case 'large':
      default:
        return 'Offer-Icon offer-image-container-large';
    }
  }
}

const OfferIcon: FC<Props> = ({ children, clickable, id = '' }) => {
  const { settings } = usePopupContext();
  const popupLayoutIconClasses: string = createPopupLayoutIconClasses(settings);

  return (
    <div
      className={cn(
        popupLayoutIconClasses,
        'relative flex flex-col justify-center overflow-x-hidden z-10',
        clickable && `Offer-Icon-clickable${popupLayoutCssPostfix(settings)}`,
        !children && 'bg-grey-4',
      )}
    >
      {children}
      <span
        id={clickable ? id : ''}
        className={cn(
          clickable && 'Icon-Overlay',
          'absolute w-full h-full bg-white top-0 bottom-0 left-0 opacity-0 transition-opacity duration-100',
        )}
      />
    </div>
  );
};

export default OfferIcon;
